module.exports = __webpack_public_path__ + "static/media/venus.ff253f70.svg";